import { useTranslation } from 'react-i18next';
import WarningTriangle from '../../images/warning_triangle.png'
import CheckIcon from '../../images/check_icon.png'
import { callIfMouseSupported, callIfTouchSupported, callIfPointerSupported } from '../General/EventSupport';
import { getUploadErrorMessage } from '../General/ErrorHandler';
import {useState } from 'react';
import './JobHistoryElement.less';
import { isReadableAsInt } from '../General/HelperFunctions';

const JobHistoryElement = ({
  failed = false,
  name = "Name",
  date = "Date",
  messages = "",
  itemID = "",
}) => {
    const { t } = useTranslation();
    const [messageOpen, setMessageOpen] = useState(false);

    const getMessage = (errors) =>{
        let errorDescription = errors !== '#' ? (" (" + errors + ")") : t('UndefinedErrorTitle');
        if(isReadableAsInt(errors)){
            let errTexts = getUploadErrorMessage(errors, t);
            errorDescription = (errTexts["Title"] + " (Error: " + errTexts["Description"] + " Code: " + errors + ")");
        }

        return errorDescription;
    }

    const formatDateTime = (input) =>  {
        const [datePart, timePart] = input.split(' ');
        const [year, month, day] = datePart.split('-');
        const [hour, minute] = timePart.split(':');

        return `${day}.${month}.${year} | ${hour}:${minute}`;
    }

    return (
        <div className="job_history_element_wrapper">
            <div className="job_history_element">
                <div className='job_history_element_left'>
                    <label>{formatDateTime(date)}</label>
                    <label>{name}</label>
                </div>
                <div className='job_history_element_right'>
                    <div className={failed ? 'job_status_flag failed' : 'job_status_flag'}>
                        <label>{failed ? t('JobHistoryJobFailed') : t('JobHistoryJobDone')}</label>
                        <img src={failed ? WarningTriangle : CheckIcon} alt={t('Checkmark')}/>
                    </div>
                    {failed && 
                        <button 
                            title={messageOpen ? t('JobHistoryHideMessage') : t('JobHistoryShowMessage')}
                            className={messageOpen ? 'job_error_button active' : 'job_error_button'}
                            onPointerUp={(e) => callIfPointerSupported(() => setMessageOpen(!messageOpen), e)}
                            onTouchStart={(e) => callIfTouchSupported(() => setMessageOpen(!messageOpen))}
                            onMouseUp={(e) => callIfMouseSupported(() => setMessageOpen(!messageOpen), e)}
                        >
                            <label>{messageOpen ? t('JobHistoryHideMessage') : t('JobHistoryShowMessage')}</label>
                        </button>
                    }
                </div>
            </div>
            {failed && messageOpen &&
                <div className='job_error_message_container'>
                    <div className='job_error_message'>
                        <label>
                            {t('JobHistoryErrorMessageItemID') + itemID + ";\n" + getMessage(messages)}
                        </label>
                    </div>
                </div>
            }
        </div>
    );
};

export default JobHistoryElement;